module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-infiniti.70558a0d.png";